import cn, { Argument as ClassNames } from 'classnames'
import './IconSelector.scss'

export interface IconSelectorOption {
  icon: JSX.Element
  label: string
  value: null | boolean | number | string
}

export interface IconSelectorProps {
  value: null | boolean | number | string
  onChange: (n: null | boolean | number | string) => void
  options: IconSelectorOption[]
  className?: ClassNames
}

const defaultProps: Partial<IconSelectorProps> = {
  className: undefined,
}

const IconSelector = ({
  value,
  onChange,
  options,
  className,
}: IconSelectorProps): JSX.Element => (
  <div className={cn('form-helpers-icon-selector', className)}>
    <div className="option-list">
      {options.map((option, optionIndex) => (
        <div key={`IconSelector-${optionIndex}`} className="option">
          <div
            className={`option-icon${value === option.value ? ' active' : ''}`}
            onClick={() => onChange(option.value)}
            onKeyPress={() => onChange(option.value)}
            role="button"
            tabIndex={0}
          >
            {option.icon}
          </div>
          <div
            key={optionIndex}
            className="option-name"
            onClick={() => onChange(option.value)}
            onKeyPress={() => onChange(option.value)}
            role="button"
            tabIndex={0}
          >
            {option.label}
          </div>
        </div>
      ))}
    </div>
  </div>
)

IconSelector.defaultProps = defaultProps
export default IconSelector
